<template>
<div>
    <header-section
        title="Support"
        set-position="relative"
        set-width="100">
    </header-section>
    <div id="app" class="o-content ie p-support">
        <icons></icons>
        <div class="flex-grid flex-grid--reduced-bottom-margin">
            <div class="flex-grid__g-6 a-form-inputs u-margin-right-60 u-r-no-margin">
                <h2 class="u-r-margin-top-0">Have a Query?</h2>
                <form action="">
                    <label for="Claim" class="u-margin-bottom-10 u-d-block">Claim Reference (optional)</label>
                    <input autocomplete="off" v-model="claimText" type="text"><br/><br/>
                    <label for="Your Query" class="u-margin-bottom-10 u-d-block">Your Query</label>
                    <textarea v-model="queryText" name="" id="" cols="30" rows="8" class="u-full-width">

                    </textarea>
                    <p v-if="sent">Your query has been received and we will be in touch soon.</p>
                    <button class="a-button" @click="sendEmail()">Send Query</button>
                </form>
            </div>
            <div class="flex-grid__g-6">

                <h2>Email Support</h2>

                <p>For more detailed assistance, support and handling guidance:</p>

                <ul>
                    <li><a href="mailto:abcquantum@bc-legal.co.uk">abcquantum@bc-legal.co.uk</a></li>
                </ul>

                <h2 class="u-r-margin-top-40">Policies</h2>

                <p class="u-r-margin-bottom-0">To view our policy documents regarding the use of this application just follow the links below:</p>

                <modal-in-the-wild modal-name="support_cookie_policy">
                    <p class="c-modal-in-the-wild">Cookie Policy</p>
                </modal-in-the-wild>

                <span class="p-support--divider u-r-margin-bottom-30 u-r-d-inline-block">|</span>

                <modal-in-the-wild modal-name="support_disclaimer">
                    <p class="c-modal-in-the-wild">Disclaimer</p>
                </modal-in-the-wild>

                <span class="p-support--divider u-r-margin-bottom-30 u-r-d-inline-block">|</span>

                <a href="https://quantum.internal.bc-legal.co.uk/api/v1/licenses/security-policy.pdf" target="_blank">
                    <p class="c-modal-in-the-wild">Security Policy</p>
                </a>

                <span class="p-support--divider u-r-margin-bottom-30 u-r-d-inline-block">|</span>

                <a href="https://quantum.internal.bc-legal.co.uk/api/v1/licenses/privacy-policy.pdf" target="_blank">
                    <p class="c-modal-in-the-wild">Privacy Policy</p>
                </a>

                <span class="p-support--divider u-r-margin-bottom-30 u-r-d-inline-block">|</span>

                <a href="https://quantum.internal.bc-legal.co.uk/api/v1/licenses/license-agreement.pdf" target="_blank">
                    <p class="c-modal-in-the-wild">License Agreement</p>
                </a>
<!--
                <span class="p-support--divider">|</span>

                <modal-in-the-wild modal-name="support_privacy_policy">
                    <p class="c-modal-in-the-wild">Privacy Policy</p>
                </modal-in-the-wild> -->
            </div>
        </div>

        <modal name="support_disclaimer" no-default-button="true">
            <disclaimer></disclaimer>
        </modal>

        <modal name="support_cookie_policy" no-default-button="true">
            <cookie-policy></cookie-policy>
        </modal>

        <modal name="support_privacy_policy" no-default-button="true">
            <privacy-policy></privacy-policy>
        </modal>
    </div>
</div>
</template>

<script type="text/babel">
    import {mapGetters, mapActions} from 'vuex';
    import Icons from 'components/Icons.vue';
    import Modal from 'components/modal/Modal.vue';
    import ModalContent from 'components/modal/ModalContent.vue';
    import ModalInTheWild from 'components/modal/ModalInTheWild.vue';
    import Disclaimer from 'components/policies/Disclaimer.vue';
    import CookiePolicy from 'components/policies/CookiePolicy.vue';
    import PrivacyPolicy from 'components/policies/PrivacyPolicy.vue';
    import HeaderSection from 'components/Header.vue';

    export default {
        name: 'support',
        data() {
            return {
                claimText: '',
                queryText: '',
                sent: false
            }
        },
        components: {
            Icons,
            Modal,
            ModalContent,
            ModalInTheWild,
            Disclaimer,
            CookiePolicy,
            PrivacyPolicy,
            HeaderSection
        },
        computed: {
            ...mapGetters('http', [
                'apiRouteRequestRunning'
            ]),
        },
        methods: {
            ...mapActions('support', ['sendMail']),
            sendEmail() {
                this.sendMail({claim: this.claimText, query: this.queryText}).then((response) => {
                    if (response) {
                        this.sent = true;
                        this.claimText = '';
                        this.queryText = '';
                        setTimeout(function () { this.reset() }.bind(this), 8000)
                    }
                });
            },
            reset() {
                this.sent = false;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Support.vue?5d4ba74f